/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch} from 'react-redux'
import {toast} from 'react-toastify'
import * as actions from '../redux/RoleAction'
import {RoleTableModelInitValues} from '../models/RoleModel'

interface Props {
  show: boolean
  handleClose: () => void
  id: string
}

const RoleDelete: FC<Props> = ({show, handleClose, id}) => {
  const [loading, setLoading] = useState(false)
  const dispatch: any = useDispatch()
  const deleteItemHandler = () => {
    setLoading(true)
    dispatch(actions.remove(id, RoleTableModelInitValues))
      .then((response: any) => {
        toast.success(response)
        setLoading(false)
      })
      .catch((error: any) => {
        toast.error(error)
        setLoading(false)
      })
  }

  return (
    <Modal
      id='kt_modal_delete_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-500px h-auto'
      show={show}
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h2>Delete Role</h2>
        </div>

        <div className='modal-body py-lg-10 px-lg-10'>
          <div className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'>
            <div className='flex-row-fluid px-lg-15'>
              <div className='current' data-kt-stepper-element='content'>
                <div className='w-100'>
                  <div className='fv-row mb-10'>
                    <label className='d-flex align-items-center fs-5 fw-bold mb-2'>
                      Are you sure you want to delete this role ?
                    </label>
                  </div>
                </div>
              </div>
              <div className='d-flex flex-stack justify-content-center pt-'>
                <div className='me-2'>
                  <button
                    title='Cancel'
                    type='button'
                    className='btn btn-lg btn-light-primary me-3'
                    onClick={() => {
                      handleClose()
                    }}
                  >
                    Cancel
                  </button>
                </div>
                <div>
                  <button
                    title='Delete'
                    type='submit'
                    className='btn btn-lg btn-primary me-3'
                    onClick={() => {
                      deleteItemHandler()
                      handleClose()
                    }}
                    disabled={loading}
                  >
                    <span className='indicator-label'>Delete</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export {RoleDelete}
